import React from 'react'

function AdminContactUs() {
  return (
    <div>AdminContactus</div>
  )
}

export default AdminContactUs